export default __webpack_public_path__ + "static/media/DCA_290x170.ad64dad9.jpg";